// frontend-dash/src/utils/socket.js
// NOTE: Socket.io backend (Render.com) has been decommissioned.
// Real-time features are handled via the Cloudflare Worker API (polling/SSE).
// This file is kept as a stub to avoid breaking imports.

let socket = null;

export const initSocket = (_token, _apiUrl) => {
    console.warn('[Socket] Real-time backend is not available. Socket.io disabled.');
    return null;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
    socket = null;
};
